/**
 * 公用接口
 */
export default {
  // 查询用户信息
  umc_getUserInfo: {
    // mock: true,
    control: 'auth/getUserInfo'
  },
  // 根据用户ID查询token
  umc_loginBusiness: {
    // mock: true,
    control: '/umc/login/loginBusiness'
  },
  // 查询个人用户是否禁用
  umc_qryUserStatus: {
    // mock: true,
    control: '/dyc/saas/common/user/qryUserStatus'
  },
  // 获取菜单（封装外部系统-运营门户的服务）
  umc_getUserMenus: {
    // mock: true,
    control: 'auth/getUserMenus'
  },
  // 导出任务进度查询
  common_taskProgressList: {
    // mock: true,
    control: 'dyc/saas/common/communal/download/fileGeneration/taskProgressList'
  },
  // 导出任务进度查询xx 新增接口20210820hlh
  common_exportExcel: {
    // mock: true,
    control: 'dyc/fsc/exportExcel'
  },
  // 导出任务创建
  fsc_taskCommit: {
    // mock: true,
    control: 'dyc/saas/common/communal/download/fileGeneration/taskCommit'
  },
  // 导出任务创建（word）
  fsc_inquirySheetInfoExportWord: {
    // mock: true,
    control: 'dyc/mall/commodity/manger/inquirySheetInfoExportWord'
  },
  // 重新导出任务创建
  fsc_taskReCommit: {
    // mock: true,
    control: 'dyc/saas/common/communal/download/fileGeneration/taskReCommit'
  },
  // 统一字典查询
  pes_dicConfigQueryData: {
    // mock: true,
    control: 'dyc/sassnogateway/saas/common/user/queryData' // control: 'dyc/common/communal/dictionary/noauth/queryData'

  },
  // 统一字典查询 (未登录)
  pes_noauthDicConfigQueryData: {
    // mock: true,
    control: 'dyc/sassnogateway/saas/common/user/noauth/queryData'
  },
  // 统一字典查询(会员重构)
  re_dicConfigQueryData: {
    // mock: true,
    control: 'dyc/sassnogateway/saas/common/user/queryData'
  },
  // 字典查询
  pes_configQueryData: {
    // mock: true,
    control: 'dyc/saas/common/communal/dicConfig/queryData'
  },
  // 查询下载进度
  fsc_taskProgressList: {
    // mock: true,
    control: 'dyc/saas/common/communal/download/fileGeneration/taskProgressList'
  },
  // 删除失败的下载
  fsc_taskDel: {
    // mock: true,
    control: 'dyc/saas/common/communal/download/fileGeneration/taskDel'
  },
  // 下载中心字典查询
  fileDownload_queryData: {
    // mock: true,
    control: 'fileDownloadPlatform/dic/query'
  },
  // 查询区域限制
  m_queryAreaAvailable: {
    // mock: true,
    control: 'dyc/mall/commodity/noauth/queryAreaAvailable'
  },
  // 采购电商商城电子超市可售商品查询API
  m_queryAvailableCommd: {
    // mock: true,
    control: 'dyc/mall/commodity/noauth/queryAvailableCommd'
  },
  // 采购电商商城电子超市商品可售状态查询能力服务API
  m_qrySkuState: {
    // mock: true,
    control: 'dyc/mall/commodity/noauth/qrySkuState'
  },
  // 商品所属频道查询
  m_queryChanneldepend: {
    // mock: true,
    control: 'dyc/mall/commodity/north/queryChanneldepend'
  },
  // 是否在可购范围【此接口删除】
  // m_dealCheck: {
  //   // mock: true,
  //   control: 'cnnc/mall/dealCheck'
  // },
  // 加入购物车
  m_addShoppingCart: {
    // mock: true,
    control: 'dyc/saas/common/user/addShoppingCart'
  },
  // 获取验证码
  getVfCode: {
    // mock: true,
    control: 'umc/users/signup/getVfcode'
  },
  // 导入查看结果
  cnnc_qryFileImpLogList: {
    // mock: true,
    control: 'dyc/saas/common/usc/qryFileImpLogList'
  },
  // 切换卖家/买家
  common_changeTradeUserType: {
    // mock: true,
    control: 'umc/users/changeUserTag'
  },
  // 物料列表查询API
  ucc_queryRsMaterialList: {
    // mock: true,
    control: 'cnnc/estore/queryRsMaterialList'
  },
  // 运营方协议附件上传
  pes_uploadAgreementAtta: {
    // mock: true,
    control: 'dyc/common/communal/fileGeneration/upload'
  },
  // 商品参数搜索
  common_selectCfcAppParamConfigList: {
    // mock: true,
    control: 'dyc/config/cfc/selectCfcAppParamConfigList'
  },
  // 公用应用-编码规则组列表详情查询
  common_qryEncodedRuleListDetailed: {
    // mock: true,
    control: 'dyc/config/cfc/qryEncodedRuleListDetailed'
  },
  // 公用应用-编码规则修改
  common_updateCfcEncodedRuleUpdateList: {
    // mock: true,
    control: 'dyc/config/cfc/updateCfcEncodedRuleUpdateList'
  },
  // 公共应用-商品中心配置参数列表查询
  common_getparametersQry: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getparametersQry'
  },
  // 公共应用-商品中心配置参数详情查询
  common_getparametersDetail: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getparametersDetail'
  },
  // 公共应用-商品中心配置参数修改
  common_dealparametersEdit: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealparametersEdit'
  },
  // 公用应用-编码规则详情
  common_qryEncodedRuleDetail: {
    // mock: true,
    control: 'dyc/config/cfc/qryEncodedRuleDetail'
  },
  // 公共应用-商品类型删除
  cnnc_deleteType: {
    // mock: true,
    control: 'dyc/busicommon/commodity/deleteType'
  },
  // 商品中心-物料分类编码查询
  common_selectCfcCommonEncodedRuleListMerge: {
    // mock: true,
    control: 'dyc/config/cfc/selectCfcCommonEncodedRuleListMerge'
  },
  // 公用应用-商品业务类别列表查API
  common_selectCfcEncodedGroupList: {
    // mock: true,
    control: 'dyc/config/cfc/selectCfcEncodedGroupList'
  },
  // 公用应用-频道搜索词查询
  dyc_getchannelsearchwordsQry: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getchannelsearchwordsQry'
  },
  // 公用应用-频道搜索词批量编辑
  dyc_dealsearchwordseditor: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealsearchwordseditor'
  },
  // 公用应用-频道搜索词详情
  dyc_getchannelsearchwordsfordetails: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getchannelsearchwordsfordetails'
  },
  // 公用应用-频道搜索词删除
  dyc_dealRmChanelConfig: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealRmChanelConfig'
  },
  // 公用应用-频道已关联搜索词查询
  dyc_getRelChannelHotWord: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getRelChannelHotWord'
  },
  // 公用应用-采购单位下拉列表
  common_qryPurchaseDropDwonList: {
    // mock: true,
    control: 'dyc/saas/common/user/org/qryPurchaseDropDwonList'
  },
  // 公用应用-返回信息列表查询API
  common_qryRspInfoList: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryRspInfoList'
  },
  // 公用应用-返回信息新增
  common_addRspInfo: {
    // mock: true,
    control: 'dyc/config/cfc/unite/addRspInfo'
  },
  // 退出登录
  users_logout: {
    // mock: true,
    control: 'umc/users/signup/logout'
  },
  // 下载文件（可重命名）
  common_download_rename: {
    // mock: true,
    control: 'dyc/common/communal/noauth/download'
  },
  // 会员子账号查询
  umc_qrySubMem: {
    // mock: true,
    control: 'dyc/saas/common/user/querySubUser'
  },
  // 切换组织机构
  umc_checkSubMem: {
    // mock: true,
    control: 'umc/login/loginSubUser'
  },
  // 根据供应商，查询是否依据合同入驻
  common_getContractQry: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getContractQry'
  },
  // 个人选择发票期限
  common_qryBillingTime: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryBillingTime'
  },
  // 公告参数列表API
  common_qryOrgPublicDicConfigListPage: {
    // mock: true,
    control: 'dyc/saas/common/user/dic/qryOrgPublicDicConfigListPage'
  },
  // 物料分类关联商品类型查询
  common_qryMaterialCommodityTypeTree: {
    // mock: true,
    control: 'dyc/busicommon/commodity/qryMaterialCommodityTypeTree'
  },
  // 供应商管理（运营侧） - 店铺推广 - 商品分类下拉
  commodity_queryDropCommdType: {
    // mock: true,
    control: 'dyc/busicommon/commodity/queryDropCommdType'
  },
  // 免登录字典查询
  common_noauthQueryData: {
    // mock: true,
    control: 'dyc/sassnogateway/saas/common/user/queryData'
  },
  // 免登录文件上传
  common_noauthUpload: {
    // mock: true,
    control: 'dyc/common/communal/noauth/fileGeneration/upload'
  },
  // 需求反馈接口
  // 采购电商扩展供应厂商查询
  ext_querySupplier: {
    // mock: true,
    control: 'dyc/saas/extension/querySupplier'
  },
  // 采购电商商城商品详情查询能力服务-价格反馈
  m_addQuestionFeedback: {
    control: 'dyc/saas/estore/addQuestionFeedBack' // mock: true

  },
  // 采购电商商城商品详情查询能力服务-我的反馈
  m_qryQuestionFeedbackList: {
    control: 'dyc/saas/estore/qryQuestionFeedbackList' // mock: true

  },
  // 采购电商商城商品详情查询能力服务-我的反馈详情
  m_qryQuestionFeedbackDetail: {
    control: 'dyc/saas/estore/qryQuestionFeedbackDetail' // mock: true

  },
  // 冗余物资-创建单位
  rm_rsAppliedRangeList: {
    control: 'dyc/saas/estore/queryOrgList' // mock: true

  },
  // 采购电商商城商品详情查询能力服务-反馈管理处理
  m_dealQuestionFeedback: {
    control: 'dyc/saas/estore/dealQuestionFeedback' // mock: true

  },
  // 供应商-不良记录详情查询
  com_querySbrBadRecordDetails: {
    control: 'cnnc/common/querySbrBadRecordDetails' // mock: true

  },
  // 供应商-供应商详情查询
  com_querySbrSupplierDetails: {
    control: 'dyc/supplier/querySbrSupplierDetails' // mock: true

  },
  // 采购电商商城商品详情查询能力服务-反馈管理创建不良记录
  m_createSbrBadRecordApply: {
    control: 'cnnc/common/createSbrBadRecordApply' // mock: true

  },
  // 供应商-不良记录申请提交
  com_submitSbrBadRecordApply: {
    control: 'cnnc/common/submitSbrBadRecordApply' // mock: true

  },
  // 供应商-不良记录修改提交
  com_submitSbrBadRecordModify: {
    control: 'cnnc/common/submitSbrBadRecordModify' // mock: true

  },
  // 供应商-不良记录申请撤销
  com_repealSbrBadRecordApply: {
    control: 'cnnc/common/repealSbrBadRecordApply' // mock: true

  },
  // 审批流可回退节点
  com_dealQryEnableBackStepList: {
    control: 'dyc/saas/self/order/qryEnableBackStepList' // mock: true

  },
  // 结算的采购单位
  com_qryOrgDropDown: {
    control: 'dyc/saas/common/enterprise/qryOrgDropDown' // mock: true

  },
  // 供需大厅-提报需求
  com_getOrderList: {
    control: 'dyc/mall/order/noauth/supply/saleOrderSupplyQueryList'
  },
  // 供需大厅-成单条目
  com_getInquiryList: {
    control: 'dyc/mall/commodity/noauth/inquirySheetSupplyQueryList'
  },
  // 快速询价-批量查询(未登录)
  com_batchSearch: {
    control: 'dyc/mall/commodity/os/quickinquiry/noauth/list'
  },
  // 快速询价-批量查询(登录后)
  com_loginBatchSearch: {
    control: 'dyc/mall/commodity/os/quickinquiry/list'
  },
  com_quickInquiryExport: {
    control: 'dyc/mall/commodity/os/quickinquiry/noauth/quickInquiryExport'
  },
  com_quickInquiryExportOld: {
    control: 'dyc/mall/commodity/os/quickinquiry/noauth/quickInquiryExportOld'
  },
  // 根据SKU查询商品供货周期
  com_querySkuListInfo: {
    control: 'dyc/common/communal/sku/querySkuListInfo'
  },
  // 首页-专业选型-数据上报
  commodity_addLog: {
    // mock: true,
    control: 'dyc/mall/commodity/search/log/noauth/addLog'
  },
  // 低代码接口 查询组织信息
  low_queryEnterpriseOrgTree: {
    // mock: true,
    control: 'metaData/liandongOrder/dycUmcEnterpriseOrgQueryService/auto0018/queryEnterpriseOrgTree'
  },
  // 商城-快速询价-纠错接口
  com_noauthlistError: {
    control: 'dyc/mall/commodity/os/quickinquiry/noauth/listError'
  },
  // 商城-快速询价-纠错接口
  com_listError: {
    control: 'dyc/mall/commodity/os/quickinquiry/listError'
  }
};